// extracted by mini-css-extract-plugin
export default {"loader":"context_loader__YwJpc","rotation":"context_rotation__hW7Jm"};